import { ActivityLogState } from './types';

export const initialState: ActivityLogState = {
  loadingActivityLog: false,
  activityLog: null,
  mostRecentActivity: null,
  showActivityLogModal: false,
  activityLogCursor: undefined,
  noMoreActivities: false,
};
